 $(function() {
        $(document).on('mouseenter','.grid-swatch:not(.product-swatch) .grid-product__colors .color-swatch',function(e){
          var img = $(this).data('img');
          var id = $(this).data('var-id');
          var is_avail = $(this).attr('data-available');
          $(this).closest('.grid-swatch-left').find('.grid-product__colors span').removeClass('selected');
          $(this).addClass('selected');
          if(is_avail == 'false'){
           $(this).closest('.product-bottom').find('.add-to-cart-grid').addClass('ctm_sold-out');
           $(this).closest('.product-bottom').find('.add-to-cart-grid').text('Sold Out');
          }else{
            $(this).closest('.product-bottom').find('.add-to-cart-grid').removeClass('ctm_sold-out');
            $(this).closest('.product-bottom').find('.add-to-cart-grid').text('Add to Cart');
          }
          if(img != '' && img != undefined && img != null){
            $(this).closest('.card-wrapper').find('.card__media img').attr('srcset',img);
          }
          $(this).closest('.card-wrapper').find('.quick-add form [name="id"]').val(id);
        })

        $(document).on('click','.grid-product__colors .color-swatch',function(e){
          var url = $(this).data('variant-url');
          console.log(url);
          window.location.href = url;
        })

        $(document).on('click','.add-to-cart-grid',function(e){
          $(this).closest('.card-wrapper').find('form [type="submit"]').trigger('click');
        })
        // $('.grid-swatch.product-swatch .grid-product__colors .color-swatch.selected').trigger('click');
         $('.ctm_size_guide').on('click',function(e) {
          $('.size_guide_trigger button').trigger('click');  
        })
   
       });